// Tracks whether the applicant has finished (submitted) the membership form.
// Until they have, the dashboard, application log and notifications stay locked:
// the header hides those links and the router sends them back to the form.
//
// The state lives in memory only. After a page reload it is "unknown" and is
// re-checked against the server, so a stale value can never unlock anything.
import { reactive } from "vue";
import axios from "axios";
import storageService from "@/services/storage.service";
import { APPLICATION_STATUS } from "@/constants/application.constants";

export const progress = reactive({
  known: false, // have we got an answer yet?
  submitted: false, // true once the form has been submitted
});

// Paths an applicant can only open after submitting the form.
const LOCKED_PATHS = ["/", "/view_log", "/notifications", "/my_application"];
export const isLockedPath = (path) =>
  LOCKED_PATHS.some((p) => (p === "/" ? path === "/" : path.startsWith(p)));

export function setApplicationSubmitted(value) {
  progress.known = true;
  progress.submitted = !!value;
}

export function resetApplicationProgress() {
  progress.known = false;
  progress.submitted = false;
}

let inflight = null;

// Asks the server (same endpoint the dashboard uses) and updates the state.
// Resolves to true / false, or null when the server could not be reached.
export function refreshApplicationProgress() {
  if (inflight) return inflight;
  inflight = axios
    .post(
      "/applications/applicant_dashboard/",
      { token: storageService.getItem("accessToken") },
      { loader: false },
    )
    .then((response) => {
      const data = (response && response.data) || {};
      const status = data.user_data && data.user_data.status;
      const submitted = !!status && status !== APPLICATION_STATUS.IN_PROGRESS;
      setApplicationSubmitted(submitted);
      return submitted;
    })
    .catch(() => null)
    .finally(() => {
      inflight = null;
    });
  return inflight;
}